import './App.css';
import supabase from './supabaseClient';
import React, { useEffect, useState } from "react";

const KC_SERVICE = process.env.REACT_APP_KC_SERVICE || 'https://kc-service-eight.vercel.app'; // 'http://localhost:3000' ; //
console.log('KC_SERVICE:', KC_SERVICE);

var freezepage = false;

var selectedCategory = 'gk'; // Default category
var currentuserid = '';
var challengeid = '';

// Check if the URL has a query string and extract the CategoryName if it exists
let paramString = window.location.href.split('?')[1];
if (paramString) {
  let queryString = new URLSearchParams(paramString);
  for (let pair of queryString.entries()) {
    if (pair[0] === 'CategoryName') {
      selectedCategory = pair[1];
    } else if (pair[0] === 'userid') {
      currentuserid = pair[1];
      const userIdLabel = document.getElementById('userid-label');
      if (userIdLabel) {
        userIdLabel.innerText = currentuserid;
      }
    } else if (pair[0] === 'cid') {
      challengeid = pair[1];
    }
  }
}

function ChallengeView() { 


const [question, setQuestion] = useState(null);
const [selectedOption, setSelectedOption] = useState('');
const [loading, setLoading] = useState(true);
const [timeLeft, setTimeLeft] = useState(0);
//const [timerAtSubmit, settimerAtSubmit] = useState(0);
const [isTimeUp, setIsTimeUp] = useState(false);
const [overallScore, setOverallScore] = useState(0);
const [data, setResponses] = useState([]);


// show timer countdown
useEffect(() => {
  if (timeLeft > 0) {
    const timerId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);
    return () => clearInterval(timerId);
  } else {
    setIsTimeUp(true);
  }
}, [timeLeft]);

// get challenge score
useEffect(() => {
  async function fetchScore() {
    console.log("in fetchscore..")
    if (!currentuserid) return;
    const { data, error } = await supabase
      .from('UserResponses')
      .select('PointsReceived, QuestionID, Response, ResponseDateTime, Questions(QuestionText)')
      .eq('challengeid', challengeid)
      .eq('userid', currentuserid.split('-')[0]);

    if (error) {
      console.log("error1:" + error.message)
      setOverallScore(0);
      setResponses([]);
      return;
    }
    console.log("error2:" )

    const total = data?.reduce((sum, row) => sum + (row.PointsReceived || 0), 0) || 0;
    setOverallScore(total);
    setResponses(data || []);
  }

  fetchScore();
}, []);

  /* Show KnowledgeScore --> Challenge score */
  useEffect(() => {
    async function handleTimeOver() {
      if (timeLeft === 0 && !freezepage) {
        //alert('Time over!');
        //const selectedOptionElem = document.querySelector('input[name="option"]:checked');
        //const answerSelected = selectedOptionElem ? selectedOptionElem.nextSibling.textContent.trim() : '';
        if (!question) return; // Prevent error if question is null
        const questionId = question.id;
        const timestamp = new Date().toISOString();
        const timeTaken = question.MaxScreenTime;
        //const isCorrect = question.Answer === answerSelected;

        await supabase
          .from('UserResponses')
          .insert([
            {
              userid: currentuserid.split('-')[0],
              QuestionID: questionId,
              Response: '',
              challengeid: challengeid,
              ResponseDateTime: timestamp,
              TimeTaken: timeTaken,
              category: selectedCategory,
              PointsReceived: question.IncorrectPoints
            }
          ]);
      }
    }
    handleTimeOver();
  }, [timeLeft, question]);

// get question from database to show on screen
useEffect(() => {
  async function fetchQuestion() {
    //console.log("point1");
    try {
      const response = await fetch(`${KC_SERVICE}/challenges_getNextQuestion`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        challengeId: challengeid,
        userId: currentuserid.split('-')[0]
      }),
      });

      console.log("point2");
      if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
      }

      //console.log("point2");
      const result = await response.json();
      // console.log(result);
      // console.log(result.Question);
      // console.log(result.Question.Question);

      //console.log("point3");
      if (result.Question) 
      {
        const fetchedQuestion = result.Question;
        setQuestion(fetchedQuestion);
        //console.log("question:" + fetchedQuestion);
        //console.log("question:" + fetchedQuestion.Category.id);

        if (fetchedQuestion.Category && fetchedQuestion.Category.id) {
          selectedCategory = fetchedQuestion.Category.id;
        }
        setTimeLeft(fetchedQuestion.MaxScreenTime);
        } 
      else {
        setQuestion(null); // No more questions
        setLoading(false);
      }
    } catch (error) {
      //console.error('Error fetching next question:', error.message);
      setLoading(false);
    }
    //console.log("point4");
    setLoading(false);

    // -- old working code starts here ... 
    /*setLoading(true);
    //console.log("point1");

    // get max question id for this challenge as responded by current user
    const { data: maxQData, error: maxQError } = await supabase
      .from('UserResponses')
      .select('QuestionID, Challenges(enddate, endtime, active)')
      .eq('userid', currentuserid.split('-')[0])
      .eq('challengeid', challengeid)
      .order('QuestionID', { ascending: false })
      .limit(1);

    if (maxQError)
    {
      //console.log("point2");
      //alert('20' + maxQError.message);
      setLoading(false);
      return;
    }
    else
    {
      //console.log("point3");
      // Check if the challenge is active and not expired
      if (maxQData.length > 0) {
        const challenge = maxQData[0].Challenge;
        if (!challenge.active || new Date(`${challenge.enddate}T${challenge.endtime}`) < new Date()) {
          setLoading(false);
          setQuestion(null); // This will trigger the "Challenge Completed!" message
          return;
        }
      }
      //alert('Max Question ID fetched: ' + (maxQData.length > 0 ? maxQData[0].QuestionID : 'None'));
    }

    //console.log("point4");
    // get next question id from ChallengeQuestions table for this challenge based on max question id
    const { data: nextQData, error: nextQError } = await supabase
      .from('ChallengeQuestions')
      .select('questionid')
      .eq('challengeid', challengeid)
      .gt('questionid', maxQData.length > 0 ? maxQData[0].QuestionID : 0)
      .order('questionid', { ascending: true })
      .limit(1);
    
    if (nextQError) 
    {
      //console.log("point5");
      //alert('21' + nextQError.message);
      setLoading(false);
      return;
    }
    else
    {
      //console.log("point6");
      //alert('Next Question ID fetched: ' + (nextQData.length > 0 ? nextQData[0].questionid : 'None'));
    }

    // get next question for this user..
    const { data, error } = await supabase
      .from('Questions')
      .select('id, QuestionText, Option1, Option2, Option3, Option4, MaxScreenTime, MinScreenTime, CorrectPoints, IncorrectPoints, Answer, Category(CategoryName, id), AnswerExplanation, KnowledgeScore')
      // .eq('Category', selectedCategory)
      .eq('Active', true)
      .eq('id', nextQData.length > 0 ? nextQData[0].questionid : -1)
      .limit(1)
      .single();

    if (!error) {
      if(data === null || data.length === 0) {
        // No more questions available in this category
        //alert("No more questions available in this category.");
        setLoading(false);
        //console.log("point7");
        return;
      }
      setQuestion(data);
      if (data.Category && data.Category.id) {
        selectedCategory = data.Category.id;
      }
      setTimeLeft(data.MaxScreenTime);
    }
    else {  
      //console.log("point8");
      alert('23' + error.message); 
    }


    //console.log("point9");
    setLoading(false);*/
  }
  fetchQuestion();
}, []);

// fetch challenge summary
useEffect(() => {
  async function fetchChallengeSummary() {
    const { data, error } = await supabase
      .from('UserResponses')
      .select('userid, Response, PointsReceived, Users(username)')
      .eq('challengeid', challengeid);

    if (error) {
      console.error('Error fetching challenge summary:', error.message);
      return;
    }
    else
    {
      console.log('Challenge summary data fetched:', data);
    }

    const summary = data.reduce((acc, row) => {
      const user = acc[row.userid] || { attempts: 0, correct: 0, incorrect: 0, score: 0, username: row.Users?.username || 'Unknown' };
      user.attempts += 1;
      user.score += row.PointsReceived || 0;
      if (row.PointsReceived > 0) {
        user.correct += 1;
      } else {
        user.incorrect += 1;
      }
      acc[row.userid] = user;
      return acc;
    }, {});

    const formattedData = Object.entries(summary)
      .map(([userid, stats]) => ({
      userid,
      ...stats
      }))
      .sort((a, b) => b.score - a.score); // Sort by score in descending order

    setResponses(formattedData);
  }

  fetchChallengeSummary();
}, []);

// fetch catgory names
useEffect(() => {
  async function fetchCategoryName() {
    if (!selectedCategory) return;
    const { data, error } = await supabase
      .from('Category')
      .select('CategoryName')
      .eq('id', selectedCategory)
      .single();

    if (!error && data) {
      // Show category name in an element with id 'category-label'
      const label = document.getElementById('category-label');
      if (label) {
        label.innerText = "Category: " + data.CategoryName;
      }
    }
  }
  fetchCategoryName();
},); // [selectedcategory]

// handle option change
const handleOptionChange = (e) => {
  setSelectedOption(e.target.value);
};

// move to next question
function navigateToQuestions(){
  window.location.href = window.location.pathname + `?cid=${challengeid}&userid=${currentuserid}&pageName=cview`;
  return;
};

// on submit click
const handleSubmit = async () => {  
  document.querySelector('button[type="submit"]').style.display = 'none';
  freezepage = true
  // Capture the current timer value in a separate variable
  //settimerAtSubmit(timeLeft);
  const selectedOption = document.querySelector('input[name="option"]:checked');
  if (!selectedOption) {
    alert("Please select an option before submitting.");
    return;
  }

  const answerSelected = `${selectedOption.nextSibling.textContent.trim()}`;
  const questionId = question.id;
  const timestamp = new Date().toISOString();
  const timeTaken = question.MaxScreenTime - timeLeft;
  const isCorrect = question.Answer === selectedOption.nextSibling.textContent.trim();

  if (isCorrect) {
    //alert(`Correct! You earned ${question.CorrectPoints} points.`);

    selectedOption.style.fontWeight = 'bold';
    selectedOption.style.color = 'green';
    const tickIcon = selectedOption.parentElement.querySelector('.tick-icon');
    if (tickIcon) {
      tickIcon.style.display = 'inline';
    }
  } 
  else {
    //alert(`Incorrect! You lost ${question.IncorrectPoints} points.`);

    const correctoption = document.querySelector(`input[name="option"][value="${question.Answer}"]`);
    correctoption.parentElement.style.fontWeight = 'bold';
    correctoption.parentElement.style.color = 'green';
    const tickIcon = correctoption.parentElement.querySelector('.tick-icon');
    if (tickIcon) {
      tickIcon.style.display = 'inline';
    }

    selectedOption.parentElement.style.fontWeight = 'bold';
    selectedOption.parentElement.style.color = 'red';
    const crossIcon = selectedOption.parentElement.querySelector('.cross-icon');
    if (crossIcon) {
      crossIcon.style.display = 'inline';
    }
  }

  if (question.AnswerExplanation) {
    const explanationBox = document.getElementById('answer-explanation-box');
    if (explanationBox) {
      explanationBox.style.display = 'block';
    }
  }

  // Save response to database
  const { error } = await supabase
    .from('UserResponses')
    .insert([
      {
        userid: currentuserid.split('-')[0], // Replace with actual user ID
        QuestionID: questionId,
        Response: answerSelected,
        challengeid: challengeid,
        ResponseDateTime: timestamp,
        TimeTaken: timeTaken,
        category: selectedCategory,
        PointsReceived: isCorrect ? question.CorrectPoints : question.IncorrectPoints
      }
    ]);

    if (error) {
      alert("Failed to submit response. Please try again." + error.message);
    } else {
      //alert("Response submitted successfully!");
    }
};

if (loading) {
  return <div>Loading...</div>;
}

if (!question) {
  return (
    <div style={{ background: '#f0f4f8', padding: '24px', borderRadius: '8px', maxWidth: 800, textAlign: 'center' }}>
      <h2 style={{ color: '#333' }}>Challenge Completed!</h2>
      <p style={{ fontSize: '1.1rem', color: '#555' }}>
        Congratulations! You have answered all the questions for this challenge. 
        Take a moment to review your performance and see how well you did. 
        You can revisit the challenge later or explore other categories to continue improving your knowledge.
      </p>

      <div style={{ marginTop: '2rem' }}>
      <h3>Challenge Summary</h3>
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          marginTop: '1rem',
          fontSize: '1rem',
          textAlign: 'left'
        }}
      >
        <thead>
          <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
            <th style={{ padding: '0.5rem', border: '1px solid #dee2e6' }}>Username</th>
            <th style={{ padding: '0.5rem', border: '1px solid #dee2e6' }}>Attempts</th>
            <th style={{ padding: '0.5rem', border: '1px solid #dee2e6' }}>Correct</th>
            <th style={{ padding: '0.5rem', border: '1px solid #dee2e6' }}>Incorrect</th>
            <th style={{ padding: '0.5rem', border: '1px solid #dee2e6' }}>Score</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index} style={{ borderBottom: '1px solid #dee2e6' }}>
              <td style={{ padding: '0.5rem', border: '1px solid #dee2e6' }}>{row.username}</td>
              <td style={{ padding: '0.5rem', border: '1px solid #dee2e6' }}>{row.attempts}</td>
              <td style={{ padding: '0.5rem', border: '1px solid #dee2e6' }}>{row.correct}</td>
              <td style={{ padding: '0.5rem', border: '1px solid #dee2e6' }}>{row.incorrect}</td>
              <td style={{ padding: '0.5rem', border: '1px solid #dee2e6' }}>{row.score}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </div>
    


  );
}

return (
  <div style={{ padding: '24px', maxWidth: 800 }}>
    {/* Show overall score */}
    <div
      style={{
        marginBottom: '1.2rem',
        padding: '0.5rem 1rem',
        background: '#e9f7ef',
        borderRadius: '6px',
        fontSize: '1.1rem',
        color: '#155724',
        border: '1px solid #c3e6cb',
        maxWidth: '400px'
      }}
    >
      <strong>My total Points:</strong> {overallScore} <br />

    </div>

          {!freezepage && (
            <p
        id="timer"
        style={{
          color: timeLeft <= 10 ? 'red' : 'black',
          fontSize: '24px',
          fontFamily: 'Georgia, serif'
        }}
            >
        {timeLeft} seconds remaining
            </p>
          )}

      <div style={{ fontSize: '0.95rem', marginBottom: '1rem', color: '#555' }}>
            <label id="category-label" style={{ marginRight: '8px', fontWeight: 'bold' }}>
        {/* Show category name directly */}
          Category: {question.Category?.CategoryName || selectedCategory}
        </label>
      </div>
      <h2>{question.QuestionText}</h2>
      <div>
        <label>
        <input
          type="radio"
          value={question.Option1}
          checked={selectedOption === question.Option1}
          onChange={handleOptionChange}
          name="option"
          disabled={(timeLeft === 0) || freezepage}
        />
        {question.Option1}
        <span
          className="tick-icon"
          style={{ display: 'none', marginLeft: '8px', color: 'green' }}
        >
          &#10003;
        </span>
        <span
          className="cross-icon"
          style={{ display: 'none', marginLeft: '8px', color: 'red' }}
        >
          &#10007;
        </span>
        </label>
      </div>
      <br />
      <div>
        <label>
        <input
          type="radio"
          value={question.Option2}
          checked={selectedOption === question.Option2}
          onChange={handleOptionChange}
          name="option"
          disabled={(timeLeft === 0) || freezepage}
        />
        {question.Option2}
        <span
          className="tick-icon"
          style={{ display: 'none', marginLeft: '8px', color: 'green' }}
        >
          &#10003;
        </span>
        <span
          className="cross-icon"
          style={{ display: 'none', marginLeft: '8px', color: 'red' }}
        >
          &#10007;
        </span>
        </label>
      </div>
      <br />
      <div>
        <label>
        <input
          type="radio"
          value={question.Option3}
          checked={selectedOption === question.Option3}
          onChange={handleOptionChange}
          name="option"
          disabled={(timeLeft === 0) || freezepage}
        />
        {question.Option3}
        <span
          className="tick-icon"
          style={{ display: 'none', marginLeft: '8px', color: 'green' }}
        >
          &#10003;
        </span>
        <span
          className="cross-icon"
          style={{ display: 'none', marginLeft: '8px', color: 'red' }}
        >
          &#10007;
        </span>
        </label>
      </div>
      <br />
      <div>
        <label>
        <input
          type="radio"
          value={question.Option4}
          checked={selectedOption === question.Option4}
          onChange={handleOptionChange}
          name="option"
          disabled={(timeLeft === 0) || freezepage}
        />
        {question.Option4}
        <span
          className="tick-icon"
          style={{ display: 'none', marginLeft: '8px', color: 'green' }}
        >
          &#10003;
        </span>
        <span
          className="cross-icon"
          style={{ display: 'none', marginLeft: '8px', color: 'red' }}
        >
          &#10007;
        </span>
        </label>
      </div>
      <br />
      <button
        type="submit"
        onClick={() => {
        // Pause the timer by preventing further countdown (do not setTimeLeft to 0)
        freezepage = true;
        //setTimeLeft(prev => prev); // This will freeze the timer by not changing its value
        handleSubmit();
        }}
        style={{
        fontSize: '1.5rem',
        padding: '0.75rem 2rem',
        marginTop: '1rem',
        borderRadius: '8px',
        backgroundColor: '#007bff',
        color: '#fff',
        border: 'none',
        cursor:
          timeLeft === 0
          ? 'not-allowed'
          : (!selectedOption || timeLeft > (question.MaxScreenTime - question.MinScreenTime))
          ? 'not-allowed'
          : 'pointer',
        opacity:
          timeLeft === 0 ||
          (!selectedOption || timeLeft > (question.MaxScreenTime - question.MinScreenTime))
          ? 0.6
          : 1
        }}
        disabled={
        timeLeft === 0 ||
        !selectedOption ||
        timeLeft > (question.MaxScreenTime - question.MinScreenTime)
        }
      >
        {timeLeft === 0
        ? 'TimeOut'
        : timeLeft > (question.MaxScreenTime - question.MinScreenTime)
        ? `Wait... (${timeLeft - (question.MaxScreenTime - question.MinScreenTime)}s)`
        : 'Submit'}
      </button>
      {/* Scoring info below submit button */}
    <div
      style={{
        marginTop: '1.2rem',
        padding: '0.75rem 1.2rem',
        background: '#f8f9fa',
        borderRadius: '6px',
        fontSize: '1.05rem',
        color: '#333',
        border: '1px solid #e0e0e0',
        maxWidth: '400px'
      }}
    >
      <strong>Scoring for this question:</strong>
      <ul style={{ margin: '0.5em 0 0 1.2em', padding: 0 }}>
        <li>
          <span style={{ color: 'green', fontWeight: 500 }}>
            +{question.CorrectPoints}
          </span>{" "}
          points for a correct answer
        </li>
        <li>
          <span style={{ color: 'red', fontWeight: 500 }}>
            {question.IncorrectPoints}
          </span>{" "}
          points for an incorrect answer
        </li>
        {/* <li>
         Knowledge level <span style={{ color: '#6f42c1', fontWeight: 500 }}>
            : {question.KnowledgeScore}
          </span>{" "}
          
        </li> */}
      </ul>
      {/* <div style={{ fontSize: '0.95rem', color: '#888', marginTop: '0.5em' }}>
        Points are for vouchers only. Knowledge Score will not be redeemed.
      </div> */}
      {question.AnswerExplanation && (
        <div
          id="answer-explanation-box"
          style={{
            marginTop: '1.2rem',
            padding: '0.75rem 1.2rem',
            background: '#fff3cd',
            borderRadius: '6px',
            fontSize: '1.05rem',
            color: '#856404',
            border: '1px solid #ffeeba',
            maxWidth: '400px',
            display: freezepage ? 'block' : 'none'
          }}
        >
          <strong>Explanation:</strong> {question.AnswerExplanation}
        </div>
      )}
    </div>
    {((timeLeft === 0) || freezepage) && (
      <button
        type="button"
        style={{
          fontSize: '1.2rem',
          padding: '0.5rem 1.5rem',
          marginTop: '1rem',
          marginLeft: '1rem',
          borderRadius: '8px',
          backgroundColor: '#28a745',
          color: '#fff',
          border: 'none',
          cursor: 'pointer'
        }}
        onClick={navigateToQuestions}
      >
        Next
      </button>
    )}
    {isTimeUp && freezepage && (
      <div style={{ marginTop: '1rem' }}>
        {selectedOption && (
          question.Answer === selectedOption ? (
            <span style={{ color: 'green', fontWeight: 'bold', fontSize: '1.2rem' }}>
              Correct Answer
            </span>
          ) : (
            <span style={{ color: 'red', fontWeight: 'bold', fontSize: '1.2rem' }}>
              Incorrect answer
            </span>
          )
        )}
      </div>
    )}

  <div style={{ marginTop: '2rem' }}>
    <h3 style={{ display: 'flex', alignItems: 'center' }}>
      Challenge Summary
      <button
        onClick={() => {
          async function refreshData() {
            console.log("starting refresh data ..");
            const { data, error } = await supabase
              .from('UserResponses')
              .select('userid, Response, PointsReceived, Users(username)')
              .eq('challengeid', challengeid);

            if (error) {
              console.error('Error refreshing challenge summary:', error.message);
              return;
            }

            const summary = data.reduce((acc, row) => {
              const user = acc[row.userid] || { attempts: 0, correct: 0, incorrect: 0, score: 0, username: row.Users?.username || 'Unknown' };
              user.attempts += 1;
              user.score += row.PointsReceived || 0;
              if (row.PointsReceived > 0) {
                user.correct += 1;
              } else {
                user.incorrect += 1;
              }
              acc[row.userid] = user;
              return acc;
            }, {});

            const formattedData = Object.entries(summary)
              .map(([userid, stats]) => ({
                userid,
                ...stats
              }))
              .sort((a, b) => b.score - a.score); // Sort by score in descending order

            if (Array.isArray(formattedData)) {
              setResponses(formattedData);
              console.log(formattedData);
            } else {
              console.error('Formatted data is not an array:', formattedData);
            }
          }

          refreshData();
        }}
        style={{
          marginLeft: '1rem',
          padding: '0.3rem 0.6rem',
          fontSize: '0.9rem',
          borderRadius: '4px',
          backgroundColor: '#007bff',
          color: '#fff',
          border: 'none',
          cursor: 'pointer'
        }}
      >
        Refresh
      </button>
    </h3>
    <table
      style={{
        width: '100%',
        borderCollapse: 'collapse',
        marginTop: '1rem',
        fontSize: '1rem',
        textAlign: 'left'
      }}
    >
      <thead>
        <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
          <th style={{ padding: '0.5rem', border: '1px solid #dee2e6' }}>Username</th>
          <th style={{ padding: '0.5rem', border: '1px solid #dee2e6' }}>Attempts</th>
          <th style={{ padding: '0.5rem', border: '1px solid #dee2e6' }}>Correct</th>
          <th style={{ padding: '0.5rem', border: '1px solid #dee2e6' }}>Incorrect</th>
          <th style={{ padding: '0.5rem', border: '1px solid #dee2e6' }}>Score</th>
        </tr>
      </thead>
      <tbody>
        {data.map((row, index) => (
          <tr key={index} style={{ borderBottom: '1px solid #dee2e6' }}>
            <td style={{ padding: '0.5rem', border: '1px solid #dee2e6' }}>{row.username}</td>
            <td style={{ padding: '0.5rem', border: '1px solid #dee2e6' }}>{row.attempts}</td>
            <td style={{ padding: '0.5rem', border: '1px solid #dee2e6' }}>{row.correct}</td>
            <td style={{ padding: '0.5rem', border: '1px solid #dee2e6' }}>{row.incorrect}</td>
            <td style={{ padding: '0.5rem', border: '1px solid #dee2e6' }}>{row.score}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
  </div>
);
}

export default ChallengeView;